import { render, staticRenderFns } from "./BookingSummary.vue?vue&type=template&id=28a8e7ea&scoped=true&"
import script from "./BookingSummary.vue?vue&type=script&lang=js&"
export * from "./BookingSummary.vue?vue&type=script&lang=js&"
import style0 from "./BookingSummary.vue?vue&type=style&index=0&id=28a8e7ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a8e7ea",
  null
  
)

component.options.__file = "BookingSummary.vue"
export default component.exports